<template>
  <div v-if="splashScreenIsVisible" class="splash-screen">
    <img
      class="splash-screen--logo"
      src="img/icons/android-chrome-192x192.png"
      alt="Meal Planner"
    />
    <div
      v-if="progressIsVisible"
      class="container splash-screen--progress-wrapper"
    >
      <p class="has-text-centered">
        {{ $t("loadingData") }}
      </p>
      <progress
        class="progress is-small is-primary splash-screen--progress"
        :value="initialReplicationProgress"
        max="1"
      >
        {{ initialReplicationProgress * 100 }} %
      </progress>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "SplashScreen",
  computed: {
    splashScreenIsVisible: function () {
      return (
        this.$store.state.isInitializedFromPersistance === false ||
        this.$store.state.initialReplicationIsInProgress === true
      );
    },
    progressIsVisible: function () {
      return (
        this.$store.state.initialReplicationIsInProgress &&
        this.$store.state.initialReplicationPendingMaxCount
      );
    },
    initialReplicationProgress: function () {
      return (
        (this.$store.state.initialReplicationPendingMaxCount -
          this.$store.state.initialReplicationPendingCount) /
        this.$store.state.initialReplicationPendingMaxCount
      );
    },
  },
});
</script>
<style>
.splash-screen .splash-screen--progress-wrapper {
  margin-top: 1.5rem;
  width: 35vw;
}
</style>
<i18n>
{
  "en": {
    "loadingData": "Loading data..."
  },
  "de": {
    "loadingData": "Lade Daten..."
  }
}
</i18n>
